import React, { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { w_labels, redir, _options, _questions, _questionsinprogress, _surveystatus, _answers, _firstrun_howto, _firstrun_sinstruction, _totaltime, _enablesurvey } from '../RecoilState';
import Text from './Text';
import { Button, message, Radio, Space, Spin } from 'antd';
import { ArrowRightOutlined, SaveOutlined, RedoOutlined, ReloadOutlined, QuestionCircleOutlined, ExclamationCircleOutlined, CloseOutlined } from '@ant-design/icons';
import _ from 'lodash';
import "core-js/actual/array";
import Sinstruction from './Sinstruction';
import howtomock from '../assets/msi.png'
import axios from 'axios';
// import Footer from './Footer';
import SurveyComplete from './SurveyComplete';
import Joyride from 'react-joyride';


const Survey = () => {

    const [labels, setLabels] = useRecoilState(w_labels);
    const [redirect, setRedirect] = useRecoilState(redir);
    const [questions, setQuestions] = useRecoilState(_questions);
    const [options, setOptions] = useRecoilState(_options);
    const [progress, setProgress] = useRecoilState(_questionsinprogress);
    const [selectedoption, setSelectedoption] = useState([]);
    const [selectedques, setSelectedques] = useState({});
    const [selectedlevalue, setSelectedlevalue] = useState("");
    const [selectedqcode, setSelectedqcode] = useState("")
    const [chosenoption, setChosenoption] = useState({})
    const [showquiz, setShowquiz] = useState(false);
    const [answered, setAnswered] = useState(false);
    // const [index, setIndex] = useState(Number);
    const [surveystatus, setSurveystatus] = useRecoilState(_surveystatus);
    const [active, setActive] = useState(Object);
    const [quesset, setQuesset] = useState(false);
    const [optnset, setOptnset] = useState(false);
    const [closeusageguide, setCloseusageguide] = useState(false);
    const [answers, setAnswers] = useRecoilState(_answers);
    const [triggersubmit, setTriggersubmit] = useState(false);
    const [run, setRun] = useState(false);
    const [firstrunhowto, setFirstrunhowto] = useRecoilState(_firstrun_howto);
    const [firstrunsinstruction, setFirstrunsinstruction] = useRecoilState(_firstrun_sinstruction);
    const [timer, setTimer] = useState(1);
    const [timerstate, setTimerstate] = useState(false);
    const [totaltime, setTotaltime] = useRecoilState(_totaltime);
    const [checkstat, setCheckstat] = useState(0);

    // useEffect(() => {console.log(firstrunhowto)},[firstrunhowto])
    // useEffect(() => {console.log(firstrunsinstruction)},[firstrunsinstruction])
    // useEffect(() => {console.log(redirect)},[redirect])
    // useEffect(() => {console.log(surveystatus)},[surveystatus])
    // useEffect(() => { console.log(timer) }, [timer])

    // first run initiate survey instructions and how to 

    useEffect(() => {
        if (redirect === "survey" && firstrunsinstruction === false && firstrunhowto === "false") {
            setFirstrunsinstruction(true);
            setSurveystatus("surveyinstructions")
        }
        else if (redirect === "survey" && firstrunsinstruction === true && firstrunhowto === "show") {
            setSurveystatus("questions")
            startTour()
            setFirstrunhowto("done")
        }
        // else if (redirect === "survey" && firstrunsinstruction === true && firstrunhowto === "done") {
        //     setSurveystatus("questions")
        // }
    }, [firstrunhowto, firstrunsinstruction])

    // useEffect(() => { console.log(surveystatus) }, [surveystatus])


    // useEffect(() => {
    //     if (run === true) { setRun(false); }
    // },[run])

    useEffect(() => {
        console.group("▶ questions");
        console.log(questions);
        console.groupEnd();

        console.group("▶ progress");
        console.log(progress);
        console.groupEnd();

        console.group("▶ options");
        console.log(options);
        console.groupEnd();

        console.group("▶ selected question");
        console.log(selectedques);
        console.groupEnd();

        console.group("▶ selected option");
        console.log(selectedoption);
        console.groupEnd();
    }, []);

    useEffect(() => {
        shuffle();
        setTimerstate(true);
    }, []); // This will shuffle the questions when the component mounts

    // timer function controlled by timerstate
    useEffect(() => {
        let interval;
        if (timerstate) {
            interval = setInterval(() => {
                setTimer(prevTime => prevTime + 1);
            }, 1000);
        } else if (!timerstate) {
            clearInterval(interval);
            // console.log("timer stopped")
        }
        return () => clearInterval(interval);
    }, [timerstate]);

    const shuffle = () => {
        if (progress.length !== 0) {
            const shuffled = [...progress];
            for (let i = shuffled.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
            }
            setShowquiz(true);
            setSelectedques(shuffled[0])
            selectoption(shuffled[0].qcat)
            setProgress(shuffled);
        }
        else {
            console.log("progress empty");
        }
    };

    const selectoption = (value) => {
        setSelectedoption([])
        setSelectedoption(options[value]);
    }

    // useEffect(() => {
    //     console.log("progress")
    //     console.log(progress)
    // }, [progress])

    // useEffect(() => {
    //     console.log("surveystatus")
    //     console.log(surveystatus)
    // }, [surveystatus])

    // useEffect(() => {
    //     if (surveystatus !== "green") {
    //         if (progress.length === 0) {
    //             setSurveystatus("submitlater")
    //             setShowquiz(false)
    //         }
    //         else {
    //             console.log("observing progress length : " + progress.length)
    //             console.log("---------------------");

    //         }
    //     }
    // }, [progress])

    // useEffect(() => {
    //     console.log("selectedques")
    //     console.log(selectedques)
    // }, [selectedques])

    // useEffect(() => {
    //     console.log("selected option")
    //     console.log(selectedoption)
    // }, [selectedoption])

    const selectionhandler = (value, index) => {
        // console.log(selectedques.qslug)
        // console.log("answer seleceted");
        // console.log(value.option.le_value);
        // console.log(index);
        setSelectedqcode(selectedques.qslug)
        setSelectedlevalue(value.option.le_value);
        setActive(value);
        setAnswered(true);
        setTimerstate(false);
    }

    // useEffect(() => {
    //     console.log(selectedques.qslug)
    //     console.log(selectedlevalue)
    // },[selectedques, selectedlevalue]);

    // useEffect(() => { console.log(totaltime) }, [totaltime]);

    const registerresponse = () => {
        const levalue = Number(selectedlevalue)
        setTotaltime(prevTotaltime => prevTotaltime + timer)
        const response = {
            question_code: selectedqcode,
            weight: levalue,
            duration: timer
        }
        setTimer(1)
        setTimerstate(false)
        setAnswers([...answers, response])
    }

    const nexthandler = () => {
        // if there are unanswered questions
        if (progress.length !== 1) {
            registerresponse()
            setShowquiz(true);
            setAnswered(false);
            setActive({});
            // setProgress([])
            const updatedprogress = progress.filter((item, index) => index !== 0);
            console.log(updatedprogress)
            setProgress(updatedprogress);
            setSelectedques(updatedprogress[0])
            selectoption(updatedprogress[0].qcat)
            setTimerstate(true)
            // setProgress(shuffled.slice(1));
            // shuffle();
        }
        // if all questions are answered
        else {
            // checkheartbeat
            // registerresponse();
            setAnswered(false);
            const levalue = Number(selectedlevalue)
            setTimerstate(false)
            const response = {
                question_code: selectedqcode,
                weight: levalue,
                duration: timer
            }
            setAnswers([...answers, response])
            setTotaltime(prevTotaltime => prevTotaltime + timer)
            const updatedAnswers = [...answers, response];
            manualsubmittoserver(updatedAnswers);
            console.log("last question")
            // setSurveystatus("submitlater")
        }
    };


    useEffect(() => {
        // console.log("recording responses")
        // console.log(recordingresponses)
        // console.log("answers")
        // console.log(answers)
    }, [answers]);

    const saveandexit = () => {
        // console.log("save and exit")
        setRedirect("dash")
        setTimer(1)
        setTimerstate(false)
    }

    const reloadhandler = () => {
        if (progress.length !== 0) {
            // console.log("reloading questions")
            // let i, l;
            // l = progress.length;
            // l = l - 2;
            // i = _.random(l);
            // console.log("reloading, index = " + i + " length = " + progress.length);
            // selectques(i);
            // selectoption(progress[i].qcat);
            // shufflewithpop();
            setShowquiz(true);
        }
        else {
            console.log("survey done")
            // console.log(progress.length)
        }
    }

    const Reload = () => {
        return (
            <>
                <div className="header-accomodate">
                    <div className="page-container m-auto">
                        <div className="flex justify-center">
                            <div className="flex flex-col justify-center">
                                <div className="mb-10 flex gap-2 items-center justify-center">
                                    <ReloadOutlined spin style={{ fontSize: '20px' }} />
                                    <Text style={"text text-center"} value={labels[31]} />
                                </div>

                                <Button type="secondary" shape="round" size="large" onClick={() => reloadhandler()}>
                                    <div className="flex justify-center gap-x-4 items-center px-4 mx-auto">
                                        <ReloadOutlined />
                                        {/* <Text style={"text"} value={labels[30]} /> */}
                                    </div>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    // survey individual screen 
    const Quiz = () => {
        return (
            <>
                <div className="header-accomodate">
                    <div className="page-container mx-auto">
                        <div className="mb-5 pb-8 border-b-2">
                            <div className="mb-5 pb-5 flex border-b-2 flex-row items-center gap-4 first-step">
                                <p className="gradient-small">Q.</p>
                                <Text style={"text-survey text-bold leading-7"} value={selectedques.question} />
                            </div>

                            {/* <Text style={"text"} value={selectedoption[0].option} /> */}
                            <div className="w-full">
                                <Radio.Group name="training-group" >
                                    {
                                        selectedoption.map((value, j) => {
                                            return (
                                                // <div className={j === 0 ? 'second-step w-[85vw]' : 'w-full'}>
                                                <button
                                                    className={j === 0 ? 'second-step mb-3 min-w-full py-1.5 px-2.5 rounded border hover:bg-orange-50' : 'mb-3 min-w-full py-1.5 px-2.5 rounded border hover:bg-orange-50'}
                                                    key={j} onClick={() => { selectionhandler(value, j) }}
                                                    style={{
                                                        borderColor: active === value ? "#F37741" : " ",
                                                        backgroundColor: active === value ? "#ffedd5" : ""
                                                    }}
                                                >
                                                    <div className="flex flex-row gap-5">
                                                        <p className="gradient-small">{j + 1}.</p>
                                                        <Text style={"text text-bold text-left"} value={value.option} />
                                                    </div>
                                                </button>
                                                // </div>
                                            )
                                        })
                                    }
                                </Radio.Group>
                            </div>
                        </div>
                        {/* <p>{progress.length} - Questions Remaining</p> */}
                        <div className="flex justify-between mt-9 mb-[90px]">
                            {/* save and exit button  */}
                            <button className='third-step border-gray rounded-[20px] border-[2px] p-[5px] hover:border-[#F37741]' type="secondary" shape="round" size="large" onClick={() => saveandexit()}>
                                <div className="flex justify-center gap-x-4 items-center px-4">
                                    <SaveOutlined />
                                    <Text style={"text"} value={labels[30]} />
                                </div>
                            </button>
                            {/* next or complete button */}
                            {
                                answered ?
                                    <Button className='fourth-step' type="secondary" shape="round" size="large" onClick={() => nexthandler()}>
                                        <div className="flex justify-center gap-x-4 items-center px-4">
                                            <Text style={"text"} value={labels[14]} />
                                            <ArrowRightOutlined />
                                        </div>
                                    </Button>
                                    :
                                    <Button className='fourth-step' type="secondary" shape="round" size="large" disabled>
                                        <div className="flex justify-center gap-x-4 items-center px-4">
                                            <Text style={"text"} value={labels[14]} />
                                            <ArrowRightOutlined />
                                        </div>
                                    </Button>
                            }

                        </div>
                    </div>
                </div>
            </>
        )
    }

    const Howto = () => {
        return (
            <>
                <div className='flex content-center justify-center'>
                    <img src={howtomock} />
                </div>
                <div className='flex justify-center content-center'>
                    <button className='p-5 border-2 rounded-full' onClick={() => setSurveystatus("questions")}>
                        <div className='flex  justify-center'>
                            <CloseOutlined />
                        </div>
                    </button>
                </div>
            </>
        )
    }

    //implement guide using react joyride 

    const startTour = () => {
        setRun(true)
    };

    const customLocale = {
        last: <Text style={"text-left text-bold"} value={labels[67]} />,
        next: <Text style={"text-left text-bold"} value={labels[14]} />,
        skip: <Text style={"text-left text-bold"} value={labels[66]} />,
        back: <Text style={"text-left text-bold"} value={labels[41]} />
    }

    const steps = [
        {
            target: '.first-step',
            content: <Text style={"text-left text-bold"} value={labels[61]} />,
            disableBeacon: true
        },
        {
            target: '.second-step',
            content: <Text style={"text-left text-bold"} value={labels[62]} />,
            disableBeacon: true
        },
        {
            target: '.third-step',
            content: <Text style={"text-left text-bold"} value={labels[63]} />,
            disableBeacon: true
        },
        {
            target: '.fourth-step',
            content: <Text style={"text-left text-bold"} value={labels[64]} />,
            disableBeacon: true
        }
    ];

    const handleJoyrideCallback = (data) => {
        // console.log(data)
        if (data.action === "reset") {
            // console.log("beacon")
            setRun(false);
            // data.lifecycle = "tooltip"
        }
    }

    const Quizfooter = () => {
        return (
            <>
                <div className="footer justify-center items-center">
                    <Space wrap>
                        <Button onClick={() => setSurveystatus("surveyinstructions")}>
                            <div className='flex content-center'>
                                <QuestionCircleOutlined />
                                &nbsp;
                                <Text style={"text-left text-bold"} value={labels[24]} />
                            </div>
                        </Button>
                        {/* <Button onClick={() => setSurveystatus("howto")}> */}
                        <Button
                            onClick={startTour}
                        >
                            <div className='flex content-center'>
                                <ExclamationCircleOutlined />
                                &nbsp;
                                <Text style={"text-left text-bold"} value={labels[60]} />
                            </div>
                        </Button>
                    </Space>
                </div>
                {/* <div>
                    <p className='text-center'>----FOR TESTING AND DEVLOPEMENT ONLY----</p>
                    <p className='text-center'>Total Questions= {questions.length} | Questions Left = {progress.length} | Answered = {answers.length}</p>
                    <p className='text-center'>--------</p>
                </div> */}
            </>
        )
    }

    const manualsubmittoserver = (value) => {
        setAnswered(false);

        // console.log(value)

        axios.get('heartbeat')
            .then((response) => {
                // console.log(response);
                if (response.data.status === "OK") {
                    // console.log("server online")
                    setSurveystatus("attempting")
                    // get current time as iso string
                    const now = new Date();
                    const isoDateTime = now.toISOString();

                    const data = {
                        submitted_at: isoDateTime,
                        duration: totaltime,
                        answers: value
                    };

                    // console.log(data);

                    axios.post('respondent/response/', data)
                        .then((response) => {
                            // console.log(response.data)
                            setAnswers([])
                            setSurveystatus("complete")
                            setTimer(1)
                        }).catch((error) => {
                            console.log(error);
                            setSurveystatus("submitlater")
                        })
                }
                else {
                    console.log("server offline")
                    setSurveystatus("submitlater")
                }
            }).catch((error) => {
                console.log(error);
                setSurveystatus("submitlater")
            })
    }

    const checkstatus = () => {
        axios.get('respondent/profile')
            .then(response => {
                const enabled = response.data.data.enabled_for_survey;
                // console.log(enabled)
                if (enabled === false) { setCheckstat(1) } else { setCheckstat(2) }
            })
    }


    const SubmitLater = () => {
        return (
            <>
                <div className="header-accomodate">
                    <div className="page-container mx-auto">
                        <div className="h-[75vh] mx-auto flex flex-col items-center justify-center">
                            <div className="mb-5 pb-8">
                                <div>
                                    <div className="flex justify-center items-center mb-5 flex-col h-36">
                                        <img src={require('../assets/no_internet.gif')} width={200} alt="lock gif" />
                                    </div>
                                </div>
                                <div className="flex flex-col items-center gap-4 justify-center">
                                    {/* <p className="gradient-small">Q.</p> */}
                                    <Text style={"gradient-heading"} value={labels[33]} />
                                    <Text style={"text-survey leading-7"} value={labels[34]} />

                                </div>
                            </div>
                            <div className="flex justify-center mt-5 mb-2">
                                <Button type="secondary" shape="round" size="large" onClick={() => manualsubmittoserver(answers)}>
                                    <div className="flex justify-center gap-x-4 items-center">
                                        <Text style={"text"} value={labels[32]} />
                                        <ArrowRightOutlined />
                                    </div>
                                </Button>
                            </div>
                            <div className="flex flex-col justify-center mt-5 mb-2">
                                {/* <p className="mb-2 mt-5">FOR TESTING PURPOSES ONLY</p> */}
                                <Button type="secondary" shape="round" size="large" onClick={() => checkstatus()}>
                                    <div className="flex justify-center gap-x-4 items-center">
                                        <p>Check Submission Status</p>
                                        {/* <ArrowRightOutlined /> */}
                                    </div>
                                </Button>
                            </div>
                            <>
                                {
                                    (checkstat === 0) ? null
                                        : (checkstat === 1) ? <p>Completed</p>
                                            : (checkstat === 2) ? <p>Not Completed</p>
                                                : <p>Contact Support</p>
                                }
                            </>
                            <div className="flex flex-col justify-center mt-5 mb-2">
                                {/* <p className="mb-2 mt-5">FOR TESTING PURPOSES ONLY</p> */}
                                <Button type="secondary" shape="round" size="large" onClick={() => logoutandreset()}>
                                    <div className="flex justify-center gap-x-4 items-center">
                                        <p>LogOut</p>
                                        {/* <ArrowRightOutlined /> */}
                                    </div>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const Submitinstatatial = () => {
        return (
            <>
                <div className="header-accomodate">
                    <div className="page-container mx-auto">
                        <div className="h-[75vh] mx-auto flex flex-col items-center justify-center">
                            <div className="mb-5 pb-8">
                                <div>
                                    <div className="flex justify-center items-center mb-5 flex-col h-36">
                                        <img src={require('../assets/severconnect.gif')} width={200} alt="lock gif" />
                                    </div>
                                </div>
                                <div className="flex flex-col items-center gap-4 justify-center">
                                    {/* <p className="gradient-small">Q.</p> */}
                                    <Text style={"gradient-heading"} value={labels[52]} />
                                    {/* <Text style={"text-survey leading-7"} value={labels[34]} /> */}

                                </div>
                            </div>
                            <div className="flex justify-center mt-5 mb-2">
                                {/* <Button type="secondary" shape="round" size="large" onClick={() => manualsubmittoserver()}>
                                    <div className="flex justify-center gap-x-4 items-center">
                                        <Text style={"text"} value={labels[32]} />
                                        <ArrowRightOutlined />
                                    </div>
                                </Button> */}
                                <Spin />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    const logoutandreset = () => {
        localStorage.removeItem('respondent_mpu_token')
        localStorage.removeItem('respondent_mpu_persist')
        setRedirect("lang")
        window.location.href = '/';
    }

    const Complete = () => {
        return (
            <>
                <div className="header-accomodate">
                    <div className="page-container mx-auto">
                        <div className="h-[75vh] mx-auto flex flex-col items-center justify-center">
                            <div className="mb-5 pb-8">
                                <div>
                                    <div className="flex justify-center items-center mb-5 flex-col h-40">
                                        <img src={require('../assets/complete.gif')} width={200} alt="lock gif" />
                                    </div>
                                </div>
                                <div className="flex flex-col items-center gap-4 justify-center">
                                    {/* <p className="gradient-small">complete</p> */}
                                    <Text style={"gradient-heading"} value={labels[35]} />
                                    <Text style={"text-survey leading-7"} value={labels[36]} />

                                </div>
                            </div>
                            <div className="flex justify-center mt-5 mb-2">
                                <Button type="secondary" shape="round" size="large" onClick={() => saveandexit()}>
                                    <div className="flex justify-center gap-x-4 items-center">
                                        <Text style={"text"} value={labels[37]} />
                                        {/* <ArrowRightOutlined /> */}
                                    </div>
                                </Button>
                            </div>

                            <div className="flex flex-col justify-center mt-5 mb-2">
                                {/* <p className="mb-2 mt-5">FOR TESTING PURPOSES ONLY</p> */}
                                <Button type="secondary" shape="round" size="large" onClick={() => logoutandreset()}>
                                    <div className="flex justify-center gap-x-4 items-center">
                                        <p>LogOut</p>
                                        {/* <ArrowRightOutlined /> */}
                                    </div>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }


    return (
        <>
            {
                (surveystatus === "surveyinstructions") ?
                    <Sinstruction />
                    :
                    (surveystatus === "questions") ?
                        showquiz ?
                            <>
                                <Quiz />
                                <Quizfooter />
                            </>
                            :
                            <Reload />
                        :
                        (surveystatus === "attempting") ?
                            // <SubmitLater />
                            <Submitinstatatial />
                            :
                            (surveystatus === "submitlater") ?
                                <SubmitLater />
                                // <Submitinstatatial />
                                :
                                (surveystatus === "howto") ?
                                    <Howto />
                                    :
                                    (surveystatus === "complete") ?
                                        <Complete />
                                        :
                                        <Complete />
            }
            {/* <Reload /> */}

            {/* guide configuration - react joyride */}
            <Joyride
                // callback={handleJoyrideCallback}
                continuous
                hideCloseButton
                run={run}
                scrollToFirstStep
                // showProgress
                showSkipButton
                steps={steps}
                callback={handleJoyrideCallback}
                locale={customLocale}
                styles={{
                    options: {
                        zIndex: 10000,
                        overlayColor: '#F46F36'
                    },
                }}
            />
        </>
        // <Quiz />
    )
}

export default Survey